import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-close-confirm-dialog', // Updated selector
  templateUrl: './close-confirm-dialog.component.html',
  styleUrls: ['./close-confirm-dialog.component.scss'],
})
export class CloseConfirmDialogComponent {
  constructor(public dialogRef: MatDialogRef<CloseConfirmDialogComponent>) {}

  onNoClick(): void {
    this.dialogRef.close();
  }

  onYesClick(): void {
    this.dialogRef.close(true);
  }
}
